import React from "react";

function InnerProductSectionHead({ currentProduct }) {
  return (
    <>
      <div class="position-relative mb-4">
        <h2 class=" font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_7 text-black text-center pt-2">
          Try This Out
        </h2>
        <h3 class="ourProductPositionhead mb-0 font_600 w-100 text-center">
          Try This Out
        </h3>
      </div>
      <p class="font_14 font_400 line_height1_7 text_light1 text-center">
        Upload your document to tryout this feature
      </p>
    </>
  );
}

export default InnerProductSectionHead;
